
import { Button } from "@/components/ui/button";
import { PlusCircle, Camera } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

interface CameraEmptyStateProps {
  searchQuery: string;
  onAddCameraClick: () => void;
}

export function CameraEmptyState({ searchQuery, onAddCameraClick }: CameraEmptyStateProps) {
  const { t } = useTranslation();
  
  return (
    <div className="text-center p-8 border rounded-lg bg-muted/10">
      {searchQuery ? (
        <p className="text-muted-foreground">{t('no_cameras_found')} "{searchQuery}"</p>
      ) : (
        <div className="space-y-4 flex flex-col items-center">
          <Camera className="h-16 w-16 text-muted-foreground opacity-20" />
          <div>
            <p className="text-muted-foreground mb-2">{t('no_cameras_yet')}</p>
            <Button variant="outline" onClick={onAddCameraClick}>
              <PlusCircle className="h-4 w-4 mr-1" />
              {t('add_first_camera')}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
